import { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'
import {
  Autocomplete,
  Chip,
  CircularProgress,
  FormHelperText,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import moment from 'moment'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import Content from 'components/content/content'
import FilterLongWidth from 'components/filterLongWidth/filter'
import {
  useDownloaServicedBokingMutation, useGetAppointmentConfirmationDropdownMutation, useGetInvoiceMutation, useGetRepairSelectionDropdownMutation,
  useGetRepairStatusDropdownMutation, useGetServiceBookingListMutation, useGetServicepackageDropdownMutation, useGetTransactionStatusDropdownMutation
} from 'store/bookingService'
import { useGetDealerDropdownBookServiceMutation } from 'store/dealer'
import { useGetCarModelPackageDropdownMutation } from 'store/voucherPackage'
import { downloadByUrl } from 'store/api'
import type {
  // PartialBookingService, 
  PartialBookingServiceFilterProps,
  PartialEvLocation
} from 'modules/partial'
import Detail from 'pages/bookCarServiceTransaction/detail/details'
import CONSTANT from 'modules/constant'
import GLOBAL from 'modules/global'
import Loading from 'components/loading/loading'
import type { ErrorProps } from 'modules/types'
import Notification from 'components/notification'
import Icon from 'components/icon'
import GlobalStyle from 'modules/styles'

const BookCarServiceTransactionList = () => {
  const [getBookingServiceList, listBookingService] = useGetServiceBookingListMutation()
  const [downloadBookingService, download] = useDownloaServicedBokingMutation()

  const [getAppointmentConfirmationDropdown, appointmentConfirmationDropdown] = useGetAppointmentConfirmationDropdownMutation()
  const [getRepairSelectionDropdown, repairSelectionDropdown] = useGetRepairSelectionDropdownMutation()
  const [getTransactionStatusDropdown, transactionStatusDropdown] = useGetTransactionStatusDropdownMutation()
  const [getRepairStatusDropdown, repairStatusDropdown] = useGetRepairStatusDropdownMutation()
  const [getDealerDropdown, dealerDropdown] = useGetDealerDropdownBookServiceMutation()
  const [getCarModelPackageDropdown, dropdownCarModel] = useGetCarModelPackageDropdownMutation()
  const [getServicePackageDropdown, servicePackageDropdown] = useGetServicepackageDropdownMutation()

  const [notification, setNotification] = useState({ open: false, message: '', isError: false });
  const [isDownloadingInvoice, setIsDownloadingInvoice] = useState(false);
  const [dialogFilter, setDialogFilter] = useState<boolean>(false)
  const [anchor, setAnchor] = useState<null | HTMLElement>(null)
  const [menu, setMenu] = useState<null | number>(null)
  const [drawerDetail, setDrawerDetail] = useState<boolean>(false)
  const [dateError, setDateError] = useState<string>('');
  const [dateVehicleDeliveredError, setDateVehicleDeliveredError] = useState<string>('');
  const [downloadInvoice] = useGetInvoiceMutation();

  const [filter, setFilter] = useState<PartialBookingServiceFilterProps>({
    AppointmentConfirmation: '',
    LicensePlate: '',
    CarModelId: '',
    RepairSelection: '',
    ServicePackage: '',
    TransactionStatus: '',
    RepairStatus: '',
    DealerId: '',
    ReservationDateStart: '',
    ReservationDateEnd: '',
    VehicleDeliveredDateStart: '',
    VehicleDeliveredDateEnd: '',
    Channel: ''
  })

  const [payload, setPayload] = useState<
    PartialBookingServiceFilterProps &
    // PartialBookingService
    PartialEvLocation
  >({
    Start: 0,
    Length: CONSTANT.DEFAULT_PAGINATION_PER_PAGE,
    // Search: {value: ''},
    Search: '',
    Filter: 'AppointmentConfirmation,LicensePlate,CarModelId,RepairSelection,ServicePackage,TransactionStatus,RepairStatus,DealerId,ReservationDateStart,ReservationDateEnd,VehicleDeliveredDateStart,VehicleDeliveredDateEnd,Channel',
    AppointmentConfirmation: '',
    LicensePlate: '',
    CarModelId: '',
    RepairSelection: '',
    ServicePackage: '',
    TransactionStatus: '',
    RepairStatus: '',
    DealerId: '',
    ReservationDateStart: '',
    ReservationDateEnd: '',
    VehicleDeliveredDateStart: '',
    VehicleDeliveredDateEnd: '',
    Channel: ''
  })

  // const onSearch = (value: string) => setPayload({ ...payload, Start: 0, Search: { value } })
  const onSearch = (value: string) => setPayload({ ...payload, Start: 0, Search: value })

  const onResync = () => {
    const formData = new FormData()

    formData.append('Start', payload.Start.toString())
    formData.append('Length', payload.Length.toString())
    formData.append('Filter.Field', payload.Filter)

    // if (!isEmpty(payload.Search.value)) formData.append('Search[value]', payload.Search.value)
    if (!isEmpty(payload.Search)) formData.append('Search', payload.Search)
    if (!isEmpty(payload.AppointmentConfirmation) && payload.AppointmentConfirmation) formData.append('AppointmentConfirmation', payload.AppointmentConfirmation)
    if (!isEmpty(payload.LicensePlate) && payload.LicensePlate) formData.append('LicensePlate', payload.LicensePlate)
    if (!isEmpty(payload.CarModelId) && payload.CarModelId) formData.append('CarModelId', payload.CarModelId)
    if (!isEmpty(payload.RepairSelection) && payload.RepairSelection) formData.append('RepairSelection', payload.RepairSelection)
    if (!isEmpty(payload.ServicePackage) && payload.ServicePackage) formData.append('ServicePackage', payload.ServicePackage)
    if (!isEmpty(payload.TransactionStatus) && payload.TransactionStatus) formData.append('TransactionStatus', payload.TransactionStatus)
    if (!isEmpty(payload.RepairStatus) && payload.RepairStatus) formData.append('RepairStatus', payload.RepairStatus)
    if (!isEmpty(payload.DealerId) && payload.DealerId) formData.append('DealerId', payload.DealerId)
    if (!isEmpty(payload.ReservationDateStart) && payload.ReservationDateStart) formData.append('ReservationDateStart', payload.ReservationDateStart)
    if (!isEmpty(payload.ReservationDateEnd) && payload.ReservationDateEnd) formData.append('ReservationDateEnd', payload.ReservationDateEnd)
    if (!isEmpty(payload.VehicleDeliveredDateStart) && payload.VehicleDeliveredDateStart) formData.append('VehicleDeliveredDateStart', payload.VehicleDeliveredDateStart)
    if (!isEmpty(payload.VehicleDeliveredDateEnd) && payload.VehicleDeliveredDateEnd) formData.append('VehicleDeliveredDateEnd', payload.VehicleDeliveredDateEnd)
    if (!isEmpty(payload.Channel) && payload.Channel) formData.append('Channel', payload.Channel)

    getBookingServiceList(formData)
  }

  const onDownload = (type?: string) => {
    const formData = new FormData()

    formData.append('Start', String(0))
    formData.append('Length', String(listBookingService.data?.recordsTotal))
    formData.append('Filter.Field', payload.Filter)

    // if (!isEmpty(payload.Search.value)) formData.append('Search[value]', payload.Search.value)
    if (!isEmpty(payload.Search)) formData.append('Search', payload.Search)
    if (!isEmpty(payload.AppointmentConfirmation) && payload.AppointmentConfirmation) formData.append('AppointmentConfirmation', payload.AppointmentConfirmation)
    if (!isEmpty(payload.LicensePlate) && payload.LicensePlate) formData.append('LicensePlate', payload.LicensePlate)
    if (!isEmpty(payload.CarModelId) && payload.CarModelId) formData.append('CarModelId', payload.CarModelId)
    if (!isEmpty(payload.RepairSelection) && payload.RepairSelection) formData.append('RepairSelection', payload.RepairSelection)
    if (!isEmpty(payload.ServicePackage) && payload.ServicePackage) formData.append('ServicePackage', payload.ServicePackage)
    if (!isEmpty(payload.TransactionStatus) && payload.TransactionStatus) formData.append('TransactionStatus', payload.TransactionStatus)
    if (!isEmpty(payload.RepairStatus) && payload.RepairStatus) formData.append('RepairStatus', payload.RepairStatus)
    if (!isEmpty(payload.DealerId) && payload.DealerId) formData.append('DealerId', payload.DealerId)
    if (!isEmpty(payload.ReservationDateStart) && payload.ReservationDateStart) formData.append('ReservationDateStart', payload.ReservationDateStart)
    if (!isEmpty(payload.ReservationDateEnd) && payload.ReservationDateEnd) formData.append('ReservationDateEnd', payload.ReservationDateEnd)
    if (!isEmpty(payload.VehicleDeliveredDateStart) && payload.VehicleDeliveredDateStart) formData.append('VehicleDeliveredDateStart', payload.VehicleDeliveredDateStart)
    if (!isEmpty(payload.VehicleDeliveredDateEnd) && payload.VehicleDeliveredDateEnd) formData.append('VehicleDeliveredDateEnd', payload.VehicleDeliveredDateEnd)
    if (!isEmpty(payload.Channel) && payload.Channel) formData.append('Channel', payload.Channel)
    if (type && !isEmpty(type)) formData.append('Content-Type', type)

    downloadBookingService(formData)
  }

  const onFilter = (state: boolean) => setDialogFilter(state)

  const onAction = (event: React.MouseEvent<HTMLElement>, index: null | number) => {
    setAnchor(event.currentTarget)
    setMenu(index)
  }

  const onRemoveAnchor = async (callback: CallableFunction) => {
    setAnchor(null)
    callback(callback)
  }


  const onChangePage = (value: number) => setPayload({ ...payload, Start: value - 1 })
  const onChangePerPage = (value: number) => setPayload({ ...payload, Length: value })

  const tableHeadTitles = [
    'Action',
    'Appointment Confirmation Status',
    'Member ID',
    'Created Date',
    'License Plate',
    'VIN',
    'Vehicle Model',
    'Odometer',
    'Customer Name',
    'Customer Phone',
    'Contact Person Name',
    'Contact Person Phone',
    'Boking Code',
    'DMS Repair No',
    'Repair Type',
    'Repair Status',
    'Delivery Method',
    'Reservation',
    'Vehicle Delivered',
    'Cancel',
    'Cancelation Reason',
    'Dealer Name',
    'Payment Method',
    'Total Price',
    'Service Package',
    'Services Fee',
    'Transaction Status',
    'Tax',
    'Grand Total',
    'Channel',
    'Source',
    'Source Type'
  ]

  const formatCurrency = (value: number) => {
    if (value < 0) {
      return `- Rp ${Math.abs(value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
    }
    return `Rp ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
  }

  const handleReservationDateStartChange = (event: Dayjs | null) => {
    const formattedDate = event ? event.format('YYYY-MM-DD') : '';
    setFilter({ ...filter, ReservationDateStart: formattedDate });

    // Validate dates
    if (filter.ReservationDateEnd && formattedDate > filter.ReservationDateEnd) {
      setDateError('Min Date cannot be greater than Max Date.');
    } else {
      setDateError('');
    }
  };

  const handleReservationDateEndChange = (event: Dayjs | null) => {
    const formattedDate = event ? event.format('YYYY-MM-DD') : '';
    setFilter({ ...filter, ReservationDateEnd: formattedDate });
    setDateError('');
  };

  const handleVehicleDeliveredStartChange = (event: Dayjs | null) => {
    const formattedDate = event ? event.format('YYYY-MM-DD') : '';
    setFilter({ ...filter, VehicleDeliveredDateStart: formattedDate });

    // Validate dates
    if (filter.VehicleDeliveredDateEnd && formattedDate > filter.VehicleDeliveredDateEnd) {
      setDateVehicleDeliveredError('Min Date cannot be greater than Max Date.');
    } else {
      setDateVehicleDeliveredError('');
    }
  };

  const handleVehicleDeliveredDateEndChange = (event: Dayjs | null) => {
    const formattedDate = event ? event.format('YYYY-MM-DD') : '';
    setFilter({ ...filter, VehicleDeliveredDateEnd: formattedDate });
    setDateVehicleDeliveredError('');
  };

  const InvoceButton = async (id: number) => {
    try {
      setIsDownloadingInvoice(true);
      const response = await downloadInvoice(Number(id)).unwrap();
      if (!response) {
        setNotification({ open: true, message: 'Error: No content available to download.', isError: true });
        setIsDownloadingInvoice(false)
        return;
      } else {
        // loading for 1 seconds
        setTimeout(() => {
          downloadByUrl(response);
          setIsDownloadingInvoice(false);
          setNotification({ open: true, message: 'Success Download Invoice.', isError: false });
        }, 1000);
      }
    } catch (error) {
      console.error('Download failed:', error);
      setNotification({ open: true, message: 'Failed to download invoice. Please try again later.', isError: true });
      setIsDownloadingInvoice(false)
    } finally {
      // Reset loading state or close notification after download
      // setNotification({ open: false, message: '', isError: false }); // close the notification immediately
    }
  };

  const openAnchor = Boolean(anchor)
  const totalPage =
    listBookingService.data && GLOBAL.tableTotalPage(listBookingService.data.recordsFiltered)

  const numbers = GLOBAL.tableNumber(payload.Start)

  useEffect(() => {
    onResync()
  }, [payload])

  return (
    <>
      <Content
        title='Book Car Service Transaction List'
        tableHeadTitles={tableHeadTitles}
        onSearch={onSearch}
        onResync={onResync}
        onFilter={() => onFilter(true)}
        onDownload={onDownload}
        downloadLoading={download.isLoading}
        useDownloadDropdownNotPDF={true}
        pagination={onChangePage}
        onChangePerPage={onChangePerPage}
        totalPage={totalPage}
        totalRecords={listBookingService.data && listBookingService.data.recordsTotal}
        page={payload.Start + 1}
        // isLoading={listBookingService.isLoading}
        isLoading={listBookingService.isLoading || isDownloadingInvoice}
        useAction={false}
      >
        {listBookingService.isSuccess &&
          listBookingService.data &&
          listBookingService.data.data.map((table, index) => (
            <TableRow key={index}>
              <TableCell>{numbers[index] + 1}</TableCell>
              <TableCell>
                <IconButton
                  id={`button-${index}-${table.id}`}
                  aria-haspopup='true'
                  aria-controls={openAnchor ? `menu-${index}-${table.id}` : undefined}
                  aria-expanded={openAnchor ? 'true' : undefined}
                  onClick={(event) => onAction(event, index)}
                >
                  <Icon icon='MoreHoriz' />
                </IconButton>
                <Menu
                  id={`menu-${index}-${table.id}`}
                  aria-labelledby={`button-${index}-${table.id}`}
                  anchorEl={anchor}
                  open={openAnchor && menu == index}
                  onClose={() => onRemoveAnchor(() => setMenu(null))}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                  }}
                >
                  <MenuItem onClick={() => onRemoveAnchor(() => setDrawerDetail(true))}>
                    View
                  </MenuItem>
                  <MenuItem onClick={() => onRemoveAnchor(() => InvoceButton(table.id))}>
                    Invoice
                  </MenuItem>
                </Menu>
                <Detail
                  open={drawerDetail && menu == index}
                  onClose={() => setDrawerDetail(false)}
                  id={table.id}
                />
              </TableCell>
              <TableCell sx={{ fontSize: 16, fontWeight: '500', textAlign: 'center' }}>
                {table.appointmentConfirmation ? (
                  <Chip
                    label={table.appointmentConfirmation}
                    color={table.appointmentConfirmation == 'Confirmed' ? 'success' : 'error'}
                  />
                ) : (
                  <Typography style={{ color: '#000000' }}>
                    <strong>-</strong>
                  </Typography>
                )}
              </TableCell>
              <TableCell>{table.memberCode || '-'}</TableCell>
              <TableCell
                style={{
                  width: table.grandTotal === null ? '50px' : '120px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left'
                }}
              >
                {table.createdAt ? moment(table.createdAt).format('DD MMM YYYY HH:mm:ss') : '-'}
              </TableCell>
              <TableCell>{table.vehicleLicensePlate || '-'}</TableCell>
              <TableCell>{table.vin || '-'}</TableCell>
              <TableCell>{table.vehicleModelName || '-'}</TableCell>
              <TableCell>{table.odometer || '-'}</TableCell>
              <TableCell>{table.customerName || '-'}</TableCell>
              <TableCell>{table.customerPhone || '-'}</TableCell>
              <TableCell>{table.contactName || '-'}</TableCell>
              <TableCell>{table.contactPhone || '-'}</TableCell>
              <TableCell>{table.bookingCode || '-'}</TableCell>
              {/* <TableCell>{table.dmsRepairId || '-'}</TableCell> */}
              <TableCell>{table.repairNo || '-'}</TableCell>
              <TableCell>{table.repairSelection || '-'}</TableCell>
              <TableCell>{table.repairStatus || '-'}</TableCell>
              <TableCell>{table.deliveryMethod || '-'}</TableCell>
              <TableCell
                style={{
                  width: table.grandTotal === null ? '50px' : '120px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left'
                }}
              >
                {table.reservationDate ? moment(table.reservationDate).format('DD MMM YYYY HH:mm:ss') : '-'}
              </TableCell>
              <TableCell
                style={{
                  width: table.grandTotal === null ? '50px' : '120px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left'
                }}
              >
                {table.vehicleDeliveredDate ? moment(table.vehicleDeliveredDate).format('DD MMM YYYY HH:mm:ss') : '-'}
              </TableCell>
              <TableCell
                style={{
                  width: table.grandTotal === null ? '50px' : '120px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left'
                }}
              >
                {table.cancelationDate ? moment(table.cancelationDate).format('DD MMM YYYY HH:mm:ss') : '-'}
              </TableCell>
              <TableCell>{table.cancelationReason || '-'}</TableCell>
              <TableCell>{table.dealerName || '-'}</TableCell>
              <TableCell>{table.paymentMethod || '-'}</TableCell>
              <TableCell
                style={{
                  width: table.grandTotal === null ? '50px' : '120px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left'
                }}
              >
                {table.totalPrice === null ? '-' : (table.totalPrice !== 0 ? formatCurrency(table.totalPrice) : `Rp 0`)}
              </TableCell>
              <TableCell>{table.servicePackage || '-'}</TableCell>
              <TableCell
                style={{
                  width: table.grandTotal === null ? '50px' : '120px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left'
                }}
              >
                {/* {table.servicesFee === null ? '-' : (table.servicesFee !== 0 ? `Rp ${GLOBAL.formatCurrency(table.servicesFee)} ` : `Rp 0`)} */}
                {table.servicesFee === null ? '-' : (table.servicesFee !== 0 ? formatCurrency(table.servicesFee) : `Rp 0`)}
              </TableCell>
              <TableCell>{table.transactionStatus || '-'}</TableCell>
              <TableCell
                style={{
                  width: table.grandTotal === null ? '50px' : '120px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left'
                }}
              >
                {table.tax === null ? '-' : (table.tax !== 0 ? formatCurrency(table.tax) : `Rp 0`)}
              </TableCell>
              <TableCell
                style={{
                  width: table.grandTotal === null ? '50px' : '120px',
                  whiteSpace: 'nowrap',
                  textAlign: 'left'
                }}
              >
                {table.grandTotal === null ? '-' : (table.grandTotal !== 0 ? formatCurrency(table.grandTotal) : `Rp 0`)}
              </TableCell>
              <TableCell>{table.channel || '-'}</TableCell>
              <TableCell>{table.source || '-'}</TableCell>
              <TableCell>{table.sourceType || '-'}</TableCell>
            </TableRow>
          ))}
      </Content>
      {isDownloadingInvoice && <Loading />}
      {listBookingService.isLoading && <Loading />}
      <FilterLongWidth
        open={dialogFilter}
        title='Filter'
        isSubmitDisabled={!GLOBAL.isFilterContainValue(filter) || dateError !== '' || dateVehicleDeliveredError !== ''}
        onClose={() => onFilter(false)}
        onCancel={() => onFilter(false)}
        onReset={() => {
          setFilter({
            AppointmentConfirmation: '',
            LicensePlate: '',
            CarModelId: '',
            RepairSelection: '',
            ServicePackage: '',
            TransactionStatus: '',
            RepairStatus: '',
            DealerId: '',
            ReservationDateStart: '',
            ReservationDateEnd: '',
            VehicleDeliveredDateStart: '',
            VehicleDeliveredDateEnd: '',
            Channel: ''
          })
          setPayload({
            ...payload,
            Start: 0,
            Length: CONSTANT.DEFAULT_PAGINATION_PER_PAGE,
            AppointmentConfirmation: '',
            LicensePlate: '',
            CarModelId: '',
            RepairSelection: '',
            ServicePackage: '',
            TransactionStatus: '',
            RepairStatus: '',
            DealerId: '',
            ReservationDateStart: '',
            ReservationDateEnd: '',
            VehicleDeliveredDateStart: '',
            VehicleDeliveredDateEnd: '',
            Channel: ''
          })
          setDateError('');
          setDateVehicleDeliveredError(''),
            onFilter(false)
        }}
        onSubmit={() => {
          setPayload({ ...payload, Start: 0, ...filter })
          onFilter(false)
        }}
      >
        <Grid container spacing={2} >
          {/* Left Side */}
          <Grid item xs={6}>
            <Grid container spacing={2} justifyContent="flex-start">
              <Grid item xs={12}>
                <Autocomplete
                  options={(appointmentConfirmationDropdown && appointmentConfirmationDropdown.data) || []}
                  getOptionLabel={(option) => option.text}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.value == value.value : false
                  }
                  onOpen={() => getAppointmentConfirmationDropdown()}
                  onChange={(_, partner) =>
                    setFilter({
                      ...filter,
                      AppointmentConfirmation: (partner && String(partner.value)) || ''
                    })
                  }
                  value={
                    (appointmentConfirmationDropdown &&
                      appointmentConfirmationDropdown.data &&
                      appointmentConfirmationDropdown.data.find((e) => String(e.value) == filter.AppointmentConfirmation)) ||
                    undefined
                  }
                  ListboxProps={GlobalStyle.ListBox}
                  renderOption={(props, item) => (
                    <li {...props} key={item.value}>
                      {item.text}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='AppointmentConfirmation'
                      label='Appointment Confirmation Status'
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {appointmentConfirmationDropdown.isLoading && <CircularProgress color='inherit' size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id='LicensePlate'
                  variant='outlined'
                  label='License Plate'
                  value={filter.LicensePlate}
                  onChange={(event) => setFilter({ ...filter, LicensePlate: event.target.value })}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={dropdownCarModel.data || []}
                  getOptionLabel={(list) => list.name}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.id == value.id : false
                  }
                  onOpen={() => getCarModelPackageDropdown()}
                  onChange={(_, id) => {
                    setFilter({
                      ...filter,
                      CarModelId: (id && String(id.id)) || ''
                    })
                  }}
                  ListboxProps={GlobalStyle.ListBox}
                  value={
                    (dropdownCarModel &&
                      dropdownCarModel.data &&
                      dropdownCarModel.data.find((e) => String(e.id) == filter.CarModelId)) ||
                    null
                  }
                  renderOption={(props, item) => (
                    <li {...props} key={item.id}>
                      {item.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='CarModelId'
                      label='Vehicle Model'
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {dropdownCarModel.isLoading && (
                              <CircularProgress color='inherit' size={20} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={(repairSelectionDropdown && repairSelectionDropdown.data) || []}
                  getOptionLabel={(option) => option.text}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.value == value.value : false
                  }
                  onOpen={() => getRepairSelectionDropdown()}
                  onChange={(_, partner) =>
                    setFilter({
                      ...filter,
                      RepairSelection: (partner && String(partner.value)) || ''
                    })
                  }
                  value={
                    (repairSelectionDropdown &&
                      repairSelectionDropdown.data &&
                      repairSelectionDropdown.data.find((e) => String(e.value) == filter.RepairSelection)) ||
                    undefined
                  }
                  ListboxProps={GlobalStyle.ListBox}
                  renderOption={(props, item) => (
                    <li {...props} key={item.value}>
                      {item.text}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='RepairSelection'
                      label='Repair Type'
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {repairSelectionDropdown.isLoading && <CircularProgress color='inherit' size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={(servicePackageDropdown && servicePackageDropdown.data) || []}
                  getOptionLabel={(option) => option.text}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.value == value.value : false
                  }
                  onOpen={() => getServicePackageDropdown()}
                  onChange={(_, partner) =>
                    setFilter({
                      ...filter,
                      ServicePackage: (partner && String(partner.value)) || ''
                    })
                  }
                  value={
                    (servicePackageDropdown &&
                      servicePackageDropdown.data &&
                      servicePackageDropdown.data.find((e) => String(e.value) == filter.ServicePackage)) ||
                    undefined
                  }
                  ListboxProps={GlobalStyle.ListBox}
                  renderOption={(props, item) => (
                    <li {...props} key={item.value}>
                      {item.text}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='ServicePackage'
                      label='Service Package'
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {servicePackageDropdown.isLoading && <CircularProgress color='inherit' size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={(transactionStatusDropdown && transactionStatusDropdown.data) || []}
                  getOptionLabel={(option) => option.text}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.value == value.value : false
                  }
                  onOpen={() => getTransactionStatusDropdown()}
                  onChange={(_, partner) =>
                    setFilter({
                      ...filter,
                      TransactionStatus: (partner && String(partner.value)) || ''
                    })
                  }
                  value={
                    (transactionStatusDropdown &&
                      transactionStatusDropdown.data &&
                      transactionStatusDropdown.data.find((e) => String(e.value) == filter.TransactionStatus)) ||
                    undefined
                  }
                  ListboxProps={GlobalStyle.ListBox}
                  renderOption={(props, item) => (
                    <li {...props} key={item.value}>
                      {item.text}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='TransactionStatus'
                      label='Transaction Status'
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {transactionStatusDropdown.isLoading && <CircularProgress color='inherit' size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Right Side */}
          <Grid item xs={6}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item xs={12}>
                <Autocomplete
                  options={(repairStatusDropdown && repairStatusDropdown.data) || []}
                  getOptionLabel={(option) => option.text}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.value == value.value : false
                  }
                  onOpen={() => getRepairStatusDropdown()}
                  onChange={(_, partner) =>
                    setFilter({
                      ...filter,
                      RepairStatus: (partner && String(partner.value)) || ''
                    })
                  }
                  value={
                    (repairStatusDropdown &&
                      repairStatusDropdown.data &&
                      repairStatusDropdown.data.find((e) => String(e.value) == filter.RepairStatus)) ||
                    undefined
                  }
                  ListboxProps={GlobalStyle.ListBox}
                  renderOption={(props, item) => (
                    <li {...props} key={item.value}>
                      {item.text}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='RepairStatus'
                      label='Repair Status'
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {repairStatusDropdown.isLoading && <CircularProgress color='inherit' size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={(dealerDropdown && dealerDropdown.data) || []}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.id == value.id : false
                  }
                  onOpen={() => getDealerDropdown()}
                  onChange={(_, dealer) =>
                    setFilter({
                      ...filter,
                      DealerId: (dealer && String(dealer.id)) || ''
                    })
                  }
                  value={
                    (dealerDropdown &&
                      dealerDropdown.data &&
                      dealerDropdown.data.find((e) => String(e.id) == filter.DealerId)) ||
                    null
                  }
                  ListboxProps={GlobalStyle.ListBox}
                  renderOption={(props, item) => (
                    <li {...props} key={item.id}>
                      {item.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='DealerId'
                      label='Dealer Name'
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {dealerDropdown.isLoading && <CircularProgress color='inherit' size={20} />}
                            {params.InputProps.endAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={[
                    { text: 'Call Center', value: 'Call Center' },
                    { text: 'MMP', value: 'MMP' },
                    { text: 'Walk-in', value: 'Walk-in' },
                    { text: 'Whatsapp', value: 'Whatsapp' }
                  ]}
                  getOptionLabel={(option) => option.text}
                  isOptionEqualToValue={(option, value) =>
                    option && value ? option.value == value.value : false
                  }
                  onChange={(_, item) =>
                    setFilter({
                      ...filter,
                      Channel: (item && item.value) || ''
                    })
                  }
                  value={
                    [
                      { text: 'Call Center', value: 'Call Center' },
                      { text: 'MMP', value: 'MMP' },
                      { text: 'Walk-in', value: 'Walk-in' },
                      { text: 'Whatsapp', value: 'Whatsapp' }
                    ].find((e) => e.value == filter.Channel) || null
                  }
                  ListboxProps={GlobalStyle.ListBox}
                  renderOption={(props, item) => (
                    <li {...props} key={item.value}>
                      {item.text}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name='Channel'
                      label='Channel'
                    />
                  )}
                />
              </Grid>
              {/* <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                  <DatePicker
                    value={filter.ReservationDateStart ? dayjs(filter.ReservationDateStart) : null}
                    onChange={(event: Dayjs | null) =>
                      setFilter({ ...filter, ReservationDateStart: (event && event.format('YYYY-MM-DD')) || '' })
                    }
                    label='Min Date'
                    format='DD-MM-YYYY'
                    slots={{
                      textField: (params) => <TextField {...params} fullWidth />
                    }}
                  />
                </LocalizationProvider>
              </Grid> */}
              {/* <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                  <DatePicker
                    value={filter.ReservationDateEnd ? dayjs(filter.ReservationDateEnd) : null}
                    minDate={dayjs(filter.ReservationDateStart)}
                    onChange={(event: Dayjs | null) =>
                      setFilter({ ...filter, ReservationDateEnd: (event && event.format('YYYY-MM-DD')) || '' })
                    }
                    label='Max Date'
                    format='DD-MM-YYYY'
                    slots={{
                      textField: (params) => <TextField {...params} fullWidth />
                    }}
                  />
                </LocalizationProvider>
              </Grid> */}

              <Grid item xs={12}>
                <Typography>Reservation Date</Typography>
                <div style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex', marginTop: 4 }}>

                  <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                    <DatePicker
                      value={filter.ReservationDateStart ? dayjs(filter.ReservationDateStart) : null}
                      // onChange={(event: Dayjs | null) =>
                      //   setFilter({ ...filter, ReservationDateStart: (event && event.format('YYYY-MM-DD')) || '' })
                      // }
                      onChange={handleReservationDateStartChange}
                      label='Min Date'
                      format='DD-MM-YYYY'
                      sx={{ width: '190px' }}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                    <DatePicker
                      value={filter.ReservationDateEnd ? dayjs(filter.ReservationDateEnd) : null}
                      minDate={dayjs(filter.ReservationDateStart)}
                      // onChange={(event: Dayjs | null) =>
                      //   setFilter({ ...filter, ReservationDateEnd: (event && event.format('YYYY-MM-DD')) || '' })
                      // }
                      onChange={handleReservationDateEndChange}
                      label='Max Date'
                      format='DD-MM-YYYY'
                      sx={{ width: '190px' }}
                    />
                  </LocalizationProvider>

                </div>
                {dateError && <FormHelperText error>{dateError}</FormHelperText>}
              </Grid>
              <Grid item xs={12}>
                <Typography>Vehicle Delivered Date</Typography>
                <div style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex', marginTop: 4 }}>

                  <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                    <DatePicker
                      value={filter.VehicleDeliveredDateStart ? dayjs(filter.VehicleDeliveredDateStart) : null}
                      // onChange={(event: Dayjs | null) =>
                      //   setFilter({ ...filter, VehicleDeliveredDateStart: (event && event.format('YYYY-MM-DD')) || '' })
                      // }
                      onChange={handleVehicleDeliveredStartChange}
                      label='Min Date'
                      format='DD-MM-YYYY'
                      sx={{ width: '190px' }}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                    <DatePicker
                      value={filter.VehicleDeliveredDateEnd ? dayjs(filter.VehicleDeliveredDateEnd) : null}
                      minDate={dayjs(filter.VehicleDeliveredDateStart)}
                      // onChange={(event: Dayjs | null) =>
                      //   setFilter({ ...filter, VehicleDeliveredDateEnd: (event && event.format('YYYY-MM-DD')) || '' })
                      // }
                      onChange={handleVehicleDeliveredDateEndChange}
                      label='Max Date'
                      format='DD-MM-YYYY'
                      sx={{ width: '190px' }}
                    />
                  </LocalizationProvider>
                </div>
                {dateVehicleDeliveredError && <FormHelperText error>{dateVehicleDeliveredError}</FormHelperText>}
              </Grid>

              {/* <Grid item xs={12}>
                <Typography>Reservation Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                  <DatePicker
                    value={filter.ReservationDateStart ? dayjs(filter.ReservationDateStart) : null}
                    onChange={handleReservationDateStartChange}
                    label='Min Date'
                    format='DD-MM-YYYY'
                    sx={{ width: '270px', marginTop: 1.3 }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                  <DatePicker
                    value={filter.ReservationDateEnd ? dayjs(filter.ReservationDateEnd) : null}
                    minDate={dayjs(filter.ReservationDateStart)}
                    onChange={handleReservationDateEndChange}
                    label='Max Date'
                    format='DD-MM-YYYY'
                    sx={{ width: '270px' }}
                  />
                </LocalizationProvider>
                {dateError && <FormHelperText error>{dateError}</FormHelperText>}
              </Grid> */}

              {/* <Grid item xs={12}>
                <Typography>Vehicle Delivered Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                  <DatePicker
                    value={filter.VehicleDeliveredDateStart ? dayjs(filter.VehicleDeliveredDateStart) : null}
                    onChange={handleVehicleDeliveredStartChange}
                    label='Min Date'
                    format='DD-MM-YYYY'
                    sx={{ width: '270px' }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
                  <DatePicker
                    value={filter.VehicleDeliveredDateEnd ? dayjs(filter.VehicleDeliveredDateEnd) : null}
                    minDate={dayjs(filter.VehicleDeliveredDateStart)}
                    onChange={handleVehicleDeliveredDateEndChange}
                    label='Max Date'
                    format='DD-MM-YYYY'
                    sx={{ width: '270px' }}
                  />
                </LocalizationProvider>
                {dateVehicleDeliveredError && <FormHelperText error>{dateVehicleDeliveredError}</FormHelperText>}
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </FilterLongWidth>

      <Notification
        open={
          !listBookingService.isLoading &&
          !listBookingService.isUninitialized &&
          !listBookingService.isSuccess
        }
        onClose={() => (listBookingService.isError ? listBookingService.reset() : location.reload())}
        isError={Boolean(listBookingService.error) && listBookingService.isError}
        message={GLOBAL.returnExceptionMessage(
          listBookingService.isError,
          listBookingService.error as ErrorProps
        )}
      />

      <Notification
        open={!download.isLoading && !download.isUninitialized}
        onClose={() => download.reset()}
        isError={Boolean(download.error) && download.isError}
        message={GLOBAL.returnExceptionMessage(download.isError, download.error as ErrorProps)}
      />

      <Notification
        open={notification.open}
        onClose={() => setNotification({ ...notification, open: false })}
        isError={notification.isError}
        message={notification.message}
      />
    </>
  )
}

export default BookCarServiceTransactionList
